const Messages = {
    custom: {
        menu: {
            configuration: "Configuration",
            theme: "Themes",
            product: "Products",
            category: "Categories",
            address: "Addresses",
            opening: "Openings",
            home:"Home"
        },
        entities: {
            theme: {
                primaryColor: 'Primary color',
                secondaryColor: 'Secondary color',
                logo: 'Logo',
                icon: 'Icon',
                active: 'Active',
            },
            product: {
                category: "Category",
                price: "Price",
                name: "Name",
                description: "Description",
                photo: "Photo",
            },
            category: {
                name: "Name",
                order: "Order",
            },
            address: {
                street: "Street",
                city: "City",
                state: "State",
                country: "Country",
                zipcode: "ZipCode",
                phone: "Telephone",
                whatsapp: "WhatsApp",
                delivery: "Has Delivery?",
            },
        }
    }
}

export default Messages;